import React from "react";

interface IProps {
    selectedIndex: number,
    data: Array<string>,
    onChange: (idx: number) => void
}

export default function Tab(props: IProps) {
    const {selectedIndex, data, onChange} = props
    
    const $tabItem = (name: string, idx: number) => {
        const isSelected = idx === selectedIndex
        return (
            <button key={idx} onClick={() => {
                onChange && onChange(idx)
            }} type={"button"} className={`inline-block flex-none rounded px-4 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out ${isSelected ? "text-primary bg-primary-light" : "text-gray-3 bg-transparent"} hover:text-primary hover:bg-primary-light focus:text-primary focus:bg-primary-light`}>
                {name}
            </button>
        )
    }
    return (
        <div className={"w-full flex flex-row items-center space-x-4"}>
            {data.map((name, idx) => {
                return $tabItem(name, idx)
            })}
        </div>
    )
}